'use client'

export default async function fetchDoc(collection: string, id: string): Promise<any | null> {
  const response = await fetch(`/api/${collection}/${id}`)
  return await response.json()
}
